import * as tslib_1 from "tslib";
import { take } from 'rxjs/operators';
import { EventEmitter, OnInit } from '@angular/core';
import { LoginService } from '../login.service';
import { ModalComponent } from './../../shared/modais/modal/modal.component';
import { LoginStorage } from './../login.storage';
import { SelectAgenteResultFactory } from './select-agente-result-factory';
import { PromotorService } from '../../services/promotor/promotor.service';
export class SelectAgenteComponent {
    constructor(loginStorage, loginService, promotorService) {
        this.loginStorage = loginStorage;
        this.loginService = loginService;
        this.promotorService = promotorService;
        this.onSelectAgente = new EventEmitter();
    }
    ngOnInit() {
        this.initObservablesModalSelecionar();
    }
    selecionar() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.verificaPromotor();
            this.initAgentes();
            if (this.agentes.length === 1) {
                this.postAgente();
            }
            else if (this.agentes.length > 1) {
                this.selecionarAgenteModal.show();
            }
            else {
                this.onSelectAgente.next(SelectAgenteResultFactory.success());
            }
        });
    }
    initAgentes() {
        this.agentes = this.loginStorage.usuario.agentesSelecionar;
        if (this.agentes && this.agentes.length > 0) {
            this.agente = this.agentes[this.getIndexAgenteSelected()];
        }
    }
    getIndexAgenteSelected() {
        const agente = this.loginStorage.agente;
        if (agente) {
            const index = this.agentes.findIndex(ag => ag.id === agente.id);
            return index >= 0 ? index : 0;
        }
        return 0;
    }
    initObservablesModalSelecionar() {
        this.selecionarAgenteModal.close.subscribe(() => {
            this.onSelectAgente.next(SelectAgenteResultFactory.canceled());
        });
        this.selecionarAgenteModal.ok.subscribe(() => {
            this.postAgente();
        });
    }
    postAgente() {
        this.loginService
            .selecionarAgente(this.agente.id).pipe(take(1))
            .subscribe(() => {
            this.loginStorage.registerAgente(this.agente);
            this.onSelectAgente.next(SelectAgenteResultFactory.success());
        }, error => this.onSelectAgente.next(SelectAgenteResultFactory.error()));
    }
    verificaPromotor() {
        return new Promise((resolve) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!!this.loginStorage.usuario.promotor.id) {
                yield this.promotorService.getOperadorLiberaCessao(this.loginStorage.usuario.promotor.id);
            }
            resolve();
        }));
    }
}
